import { inject, Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";

import { ModalService } from "../services/modal.service";

export interface PromptUnsavedChanges {
    hasChanges: () => boolean;
}

@Injectable({
    "providedIn": "root"
})
export class SaveChangesGuard implements CanDeactivate<PromptUnsavedChanges> {
    private modalService = inject(ModalService);

    canDeactivate (component: PromptUnsavedChanges | null | undefined) {
        if (!component || typeof component.hasChanges !== "function") {
            return true;
        }

        if (component.hasChanges()) {
            return this.modalService.showWarningModal("You have unsaved changes.<br><br> Are you sure you want to leave this page?");
        }

        return true;
    }
}
